GrouponValidate = require "../../../../../groupon/frontend/validate"
Backbone = require 'backbone'
Backbone.$ = $
SupportUserContactInfoTemplate = require '../../../../user_contact_info.html.mustache'

class EmailFormUSUserContactInfoView extends Backbone.View
  tagName:'li'
  className: 'requestedFields'

  initialize: (options) ->
    @options = options || {}
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @model = @options.model
    @isInputCompulsory = @model.required
    @template = SupportUserContactInfoTemplate

  events:
    'change #contactOnlyByMail': 'onContactOnlyByMail'
    'keyup #contact_phone': 'enableDisableSubmitButton'
    'keyup #contact_email': 'enableDisableSubmitButton'

  render: ->
    @$el.append toHtml(@template, {}, @I18nScope)
    @changeDescriptionText()

  enableDisableSubmitButton: ->
    @options.validateEmailForm.call()

  changeDescriptionText: ->
    $('#ticket_description').text(I18n.translate('js.modules.support.additional_details_example'))

  contactOnlyByMail: ->
    $('#contactOnlyByMail').is(':checked')

  onContactOnlyByMail: ->
    $('#validateContactPhone').css('display','none')
    if @contactOnlyByMail()
      @getUserPhoneElement().attr('disabled','disabled')
      @getUserPhoneElement().val("")
      @getUserEmailElement().css('display','block')
      if currentUser?
        @getUserEmailElement().val(currentUser?.email)
      else
        @getUserEmailElement().val($('#tcktUsermail').val())
      $(".stepThreeLabel #contactOnlyByPhonenumberMandatory").css('display','none')
      $("#contactOnlyByMailMandatory").css('display','inline')
      $(".inputField#contact_phone").val('')
    else
      @getUserPhoneElement().removeAttr('disabled')
      @getUserEmailElement().css('display','none')
      $('#validateContactEmail').css('display','none')
      $("#contactOnlyByMailMandatory").css('display','none')
      $(".stepThreeLabel #contactOnlyByPhonenumberMandatory").css('display','inline')
      $(".inputField#contact_email").val('')
    @options.validateEmailForm.call()

  validateContactEmail: ->
    email_id = @getUserEmailElement()?.val()?.trim()
    if GrouponValidate.email(email_id)
      $('#validateContactEmail').css('display','none')
      return true
    else
      $('#validateContactEmail').css('display','block')
      return false

  validateContactPhone: ->
    phoneNum = @getUserPhoneElement()?.val()?.trim()
    if GrouponValidate.phone(phoneNum)
      $('#validateContactPhone').css('display','none')
      return true
    else
      $('#validateContactPhone').css('display','block')
      return false

  populateInput: (data) ->
    data.user_given_email = @getUserEmailElement()?.val()?.trim()
    data.user_given_phone = @getUserPhoneElement()?.val()?.trim()
    data.contact_only_email = @contactOnlyByMail()
    data.userContactInfoView = true

  isInputValid: ->
    if @contactOnlyByMail()
      @validateContactEmail()
    else
      @validateContactPhone()

  getUserPhoneElement: ->
    @$el.find('#contact_phone')

  getUserEmailElement: ->
    @$el.find('#contact_email')

  isInputGiven: ->
    if @contactOnlyByMail()
      @getUserEmailElement()?.val()?.trim().length > 0
    else
      @getUserPhoneElement()?.val()?.trim().length > 0

module.exports = EmailFormUSUserContactInfoView
